module.exports = __webpack_public_path__ + "static/rosewaffle-e8139cd699d4e9081080444311bef2d4.jpeg";